/**
 * Grün = kein Handlungsbedarf (docs/produkt/02-fachliche-konzepte.md).
 *
 * Seit die Ziel-Abdeckung Lieferzeit + Ziel-Reichweite umfasst, tragen auch
 * grüne Artikel eine rechnerische Empfehlungsmenge > 0. Die Menge bleibt in
 * ComputedMetric/Trace erhalten, wird bei Grün aber nur unterdrückt
 * dargestellt - analog zur Risikowert-Unterdrückung in OutOfStock.tsx.
 *
 * Die Zahl bleibt im `title`-Tooltip auffindbar: Auswahl-Checkboxen in der
 * Lagerrisiken-Ansicht übernehmen Zeilen unverändert in eine Bestellliste,
 * eine komplett unsichtbare Menge wäre dort eine stille Fehlerquelle.
 */
export interface RecommendedQtyDisplay {
  text: string;
  title?: string;
}

export function formatRecommendedQty(qty: number, severity: string): RecommendedQtyDisplay {
  if (severity === 'green') {
    return {
      text: '—',
      title: `Rechnerisch ${qty.toLocaleString('de-DE')} Stk. — grün: kein Handlungsbedarf`,
    };
  }

  return { text: qty > 0 ? qty.toLocaleString('de-DE') : '—' };
}
